import { Controller } from "@hotwired/stimulus"

// The pencil on a home's Ask chip (assistants/_quick_actions): puts the chip's
// question in Jane's ask box, cursor at the end, to change before sending.
// Only offered when the home has an ask box ([data-fillable] shows the
// pencils); without one the chip just asks.
export default class extends Controller {
    connect() {
        this.element.toggleAttribute("data-fillable", Boolean(this._field()))
    }

    fill(event) {
        event.preventDefault()
        event.stopPropagation()
        const field = this._field()
        if (!field) return
        field.value = event.params.prompt || ""
        field.dispatchEvent(new Event("input", { bubbles: true }))
        field.focus()
        const end = field.value.length
        field.setSelectionRange?.(end, end)
    }

    _field() {
        return document.querySelector(".assistant-phone--home .assistant-compose-field[name=message], .assistant-home-panel .assistant-compose-field[name=message], .home-desktop-item--composer .assistant-compose-field[name=message]")
    }
}
